"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _classnames = _interopRequireDefault(require("classnames"));

var _GalleryArrow = _interopRequireDefault(require("./GalleryArrow"));

var _GalleryImage = _interopRequireDefault(require("./GalleryImage"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    dot: {
      width: 16,
      height: 16,
      backgroundColor: palette.grey.main,
      marginRight: spacing(1)
    },
    dotActive: {
      backgroundColor: palette.link.main
    },
    stepper: {
      position: 'relative',
      justifyContent: 'center',
      padding: spacing(2, 0),
      backgroundColor: palette.background.darken
    }
  };
});

var ProductImagesGallery = function ProductImagesGallery(_ref2) {
  var images = _ref2.images,
      _ref2$isTangoCard = _ref2.isTangoCard,
      isTangoCard = _ref2$isTangoCard === void 0 ? false : _ref2$isTangoCard,
      onNextImage = _ref2.onNextImage,
      onPrevImage = _ref2.onPrevImage,
      onSwipeImage = _ref2.onSwipeImage,
      _ref2$overrideClasses = _ref2.overrideClasses,
      overrideClasses = _ref2$overrideClasses === void 0 ? {} : _ref2$overrideClasses,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 352 : _ref2$height,
      arrowColor = _ref2.arrowColor;
  var classes = useStyles();

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeStep = _useState2[0],
      setActiveStep = _useState2[1];

  var maxSteps = images.length;
  var showStepper = images.length > 1;
  var backgroundSize = isTangoCard ? 'contain' : 'cover';
  var handleNext = (0, _react.useCallback)(function () {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
    onNextImage && onNextImage();
  }, [onNextImage]);
  var handleBack = (0, _react.useCallback)(function () {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep - 1;
    });
    onPrevImage && onPrevImage();
  }, [onPrevImage]);
  var handleStepChange = (0, _react.useCallback)(function (step) {
    var dir = step > activeStep ? 'next' : 'prev';
    onSwipeImage && onSwipeImage(dir);
    setActiveStep(step);
  }, [activeStep, onSwipeImage]);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1,
    flexGrow: 1
  }, /*#__PURE__*/_react["default"].createElement(_reactSwipeableViews["default"], {
    axis: "x",
    index: activeStep,
    enableMouseEvents: true,
    onChangeIndex: handleStepChange
  }, images.map(function (image) {
    return /*#__PURE__*/_react["default"].createElement(_material.Box, {
      key: image,
      height: height,
      minWidth: 1
    }, /*#__PURE__*/_react["default"].createElement(_GalleryImage["default"], {
      image: image,
      backgroundSize: backgroundSize,
      height: height
    }));
  })), showStepper && /*#__PURE__*/_react["default"].createElement(_material.MobileStepper, {
    classes: {
      root: (0, _classnames["default"])(classes.stepper, overrideClasses.stepper),
      dot: (0, _classnames["default"])(classes.dot, overrideClasses.dot),
      dotActive: (0, _classnames["default"])(classes.dotActive, overrideClasses.dotActive)
    },
    steps: maxSteps,
    variant: "dots",
    activeStep: activeStep,
    nextButton: /*#__PURE__*/_react["default"].createElement(_GalleryArrow["default"], {
      icon: "arrow-right",
      right: -20,
      disabled: activeStep === maxSteps - 1,
      onSwitchImage: handleNext,
      positionX: height < 352 ? -157 : undefined,
      color: arrowColor
    }),
    backButton: /*#__PURE__*/_react["default"].createElement(_GalleryArrow["default"], {
      icon: "arrow-left",
      left: -20,
      disabled: activeStep === 0,
      positionX: height < 352 ? -157 : undefined,
      color: arrowColor,
      onSwitchImage: handleBack
    })
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(ProductImagesGallery);

exports["default"] = _default;